import SvgIcon from './SvgIcon.vue'
import BoxedSvgIcon from './BoxedSvgIcon.vue'

export { SvgIcon, BoxedSvgIcon }
export default SvgIcon
